import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AccordionContext } from './accordion-context';

export const Accordion = ({ children, single = true }) => {
  const [openedItems, setOpenedItems] = useState([]);

  const handleToggleItem = useCallback(
    (id, opened) => {
      if (opened) {
        setOpenedItems(single ? [id] : [...openedItems, id]);
        return;
      }

      setOpenedItems(openedItems.filter(itemId => itemId !== id));
    },
    [openedItems, single]
  );

  return (
    <AccordionContext.Provider
      value={{
        openedItems,
        onToggleItem: handleToggleItem,
      }}
    >
      {children}
    </AccordionContext.Provider>
  );
};

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  single: PropTypes.bool,
};
